import { render, staticRenderFns } from "./ShopReturn.vue?vue&type=template&id=962c3356&"
import script from "./ShopReturn.vue?vue&type=script&lang=js&"
export * from "./ShopReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports